export default __webpack_public_path__ + "static/sol-if-89103aaca486bac8b0ed6aad11dc9f5f.webp";